import JassEnum from './enum';

/**
 * type animtype
 */
export default class JassAnimType extends JassEnum {}
